// Add the email addresses allowed to use Analytics, then rebuild the app.
// An empty list denies access to everyone. This controls the React UI only;
// the analytics server must enforce its own authentication/authorization.
export const ANALYTICS_ALLOWED_EMAILS = [
  'madhu@caledontechnologies.com',
  'sai@caledontechnologies.com',
  'manoj@caledontechnologies.com',
  'vky@routes.ca',
  'rajiv@routes.ca',
];

export const ANALYTICS_URL = 'https://analytics.rentalcrow.com/';

export const canAccessAnalytics = (user) => {
  const email = String(user?.userEmail || '').trim().toLowerCase();
  return Boolean(email) && ANALYTICS_ALLOWED_EMAILS.some(
    (allowedEmail) => allowedEmail.trim().toLowerCase() === email
  );
};
